import React, { useEffect } from "react";
import Apiaxios from "../utils/Axios";

interface ApiInitializerContainerProps {
  children: React.ReactNode;
}

export const ApiInitializerContainer: React.FC<
  ApiInitializerContainerProps
> = ({ children }) => {
  // Solo probamos la conexión al montar
  useEffect(() => {
    const testConnection = async () => {
      try {
        await Apiaxios.get("/");
      } catch (err) {
        console.error("Error conectando a la API:", err);
      }
    };
    testConnection();
  }, []);

  // Renderizamos los hijos sin mensajes
  return <>{children}</>;
};
